import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const {
    t
  } = useLanguage();
  const faqs = [{
    q: t('faq.q1'),
    a: t('faq.a1')
  }, {
    q: t('faq.q2'),
    a: t('faq.a2')
  }, {
    q: t('faq.q3'),
    a: t('faq.a3')
  }, {
    q: t('faq.q4'),
    a: t('faq.a4')
  }, {
    q: t('faq.q5'),
    a: t('faq.a5')
  }, {
    q: t('faq.q6'),
    a: t('faq.a6')
  }, {
    q: t('faq.q7'),
    a: t('faq.a7')
  }, {
    q: t('faq.q8'),
    a: t('faq.a8')
  }, {
    q: t('faq.q9'),
    a: t('faq.a9')
  }, {
    q: t('faq.q10'),
    a: t('faq.a10')
  }];
  return <section className="w-full py-16 md:py-24 bg-[#F5F1E8]" data-id="element-222">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-223">
        <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-12 text-center" data-id="element-224">
          {t('faq.title')}
        </h2>
        <div className="space-y-4" data-id="element-225">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-[#3E2723]/10 overflow-hidden" data-id="element-226">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-[#C2410C] focus:ring-inset" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} aria-expanded={openIdx === idx} data-id="element-227">
                <span className="text-lg font-semibold text-[#3E2723] pr-4" data-id="element-228">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-[#C2410C] flex-shrink-0" data-id="element-229" /> : <ChevronDown className="w-5 h-5 text-[#C2410C] flex-shrink-0" data-id="element-230" />}
              </button>
              {openIdx === idx && <div className="px-6 pb-5 text-[#3E2723]/70 leading-relaxed" data-id="element-231">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}